import {IconButton} from "@mui/material";
import React, {useEffect, useRef} from "react";
import {Help} from "@mui/icons-material";
import {CustomPopper} from "~/components/customPopper/CustomPopper";

export const HelpComponent: React.FC<{
    helpContent: React.ReactNode;
    onChange?: (prevState: boolean) => void,
}> = props => {

    const [popupElement, setPopupElement] = React.useState<null | HTMLElement>(null);
    const open = Boolean(popupElement);
    // CustomPopper closes on any mousedown outside the popout, the help button included: remember that it was open, so
    // the click that follows closes it instead of opening it again.
    const wasOpen = useRef(false);

    useEffect(() => {
        if (props.onChange) {
            props.onChange(open);
        }
    }, [props, open])

    return <span>
        <IconButton
            onMouseDown={() => {
                wasOpen.current = open;
            }}
            onClick={(event: React.MouseEvent<HTMLElement>) => {
                setPopupElement(wasOpen.current ? null : event.currentTarget);
            }}>
            <Help/>
        </IconButton>
        {/* In a portal (not clipped by cards) on the popper layer, like the app's other popouts. */}
        <CustomPopper open={open} anchorEl={popupElement} placement="bottom" disablePortal={false}
                      onClose={() => setPopupElement(null)} paperSx={{maxWidth: 'min(480px, calc(100vw - 32px))'}}>
            <div className="dashboard-card-popout help-tooltip">{props.helpContent}</div>
        </CustomPopper>
    </span>;
};
